import { Link } from "react-router-dom";
import { analytics, site } from "@/content";

export default function AnalyticsFooter() {
  const footer = analytics.footer;

  return (
    <footer className="bg-white dark:bg-white/[0.04] border-t border-slate-200 dark:border-white/[0.09]">
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="flex-1 max-w-xs">
            <Link
              to="/"
              className="flex items-center gap-2.5 mb-4 cursor-pointer group"
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-blue-600 transition-all duration-300 group-hover:scale-110 group-hover:rotate-6 group-hover:bg-blue-500">
                <i className="ri-bar-chart-box-line text-white text-sm transition-transform duration-300 group-hover:scale-110"></i>
              </div>
              <span className="font-extrabold text-lg tracking-tight text-slate-900 dark:text-white transition-colors duration-300 group-hover:text-blue-700">
                {site.brand.name}
                <span className="text-blue-600 dark:text-blue-400 transition-colors duration-300 group-hover:text-blue-500">
                  {site.brand.suffix}
                </span>
              </span>
            </Link>
            <p className="text-slate-500 dark:text-white/60 text-sm leading-relaxed mb-5">
              {footer.description}
              <br />
              {site.brand.legal}
            </p>
            <div className="flex gap-3">
              {site.socials.map((social) => (
                <a
                  key={social.key}
                  href={social.href}
                  aria-label={social.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-slate-100 text-slate-500 dark:text-white/60 hover:bg-blue-600 hover:text-white transition-all cursor-pointer"
                >
                  <i className={`${social.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {footer.columns.map((column) => (
              <div key={column.title}>
                <div className="text-slate-900 dark:text-white font-semibold text-sm mb-4">
                  {column.title}
                </div>
                <ul className="space-y-2.5">
                  {column.links.map((link) => (
                    <li key={link.text}>
                      <a
                        href={link.href}
                        className="text-slate-500 dark:text-white/60 text-sm hover:text-slate-900 transition-colors cursor-pointer"
                      >
                        {link.text}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-200 dark:border-white/[0.09] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 dark:text-white/60 text-xs">{footer.copyright}</p>
          <div className="flex gap-5">
            {footer.legalLinks.map((link) => (
              <a
                key={link.text}
                href={link.href}
                className="text-slate-500 dark:text-white/60 text-xs hover:text-slate-600 cursor-pointer"
              >
                {link.text}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
